import { Routes, Route } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { SCREEN_PART_CONFIG } from './base/screen-part-configs';

/**
 * 화면 파트(인스턴스) 라우팅
 * 파트 정의 라우팅은 screen-part-definition.routes.ts 사용
 */
export const screenPartRoutes: Routes = [
  {
    path: SCREEN_PART_CONFIG.routePath,
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/screen-part-list-page/screen-part-list-page.component'
          ).then((m) => m.ScreenPartListPageComponent),
        data: {
          screenPartKey: 'package',
          config: SCREEN_PART_CONFIG,
          title: 'brandFn.menu.screenPart',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/screen-part-detail-page/screen-part-detail-page.component'
              ).then((m) => m.ScreenPartDetailPageComponent),
            data: {
              screenPartKey: 'package',
              config: SCREEN_PART_CONFIG,
              title: `프리셋 관리 상세`,
            },
          },
        ],
      },
    ],
  },
];
